import { create } from 'zustand'

import { toast } from '@/shared/lib/toast'

import * as purchaseOrderApi from '../api/purchaseOrder.api'

export const usePurchaseOrderStore = create((set, get) => ({
  purchaseOrders: [],
  isLoading: false,
  isSubmitting: false,
  error: null,

  fetchPurchaseOrders: async () => {
    set({ isLoading: true, error: null })

    try {
      const result = await purchaseOrderApi.getPurchaseOrders()

      set({
        purchaseOrders: result.data ?? [],
        isLoading: false,
        error: null,
      })

      return result
    } catch (error) {
      const message = error.message || 'Failed to fetch purchase orders'

      set({
        isLoading: false,
        error: message,
      })

      toast.error(message)
      throw error
    }
  },

  createPurchaseOrder: async (payload) => {
    if (get().isSubmitting) return null

    set({ isSubmitting: true, error: null })

    try {
      const result = await purchaseOrderApi.createPurchaseOrder(payload)

      toast.success(result.message || 'Purchase order created successfully')

      await get().fetchPurchaseOrders()

      set({ isSubmitting: false, error: null })

      return result
    } catch (error) {
      const message = error.message || 'Failed to create purchase order'

      set({
        isSubmitting: false,
        error: message,
      })

      toast.error(message)
      throw error
    }
  },

  fetchNextPurchaseOrderNumber: async (date) => {
    try {
      const result = await purchaseOrderApi.getNextPurchaseOrderNumber(date)
      return result.data?.purchaseOrderNumber || null
    } catch {
      return null
    }
  },
}))
